<template>
  <div class="mt-2">
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div class="table-wrapper">
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono record da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template
            v-slot:head(check)="data"
            v-if="hasChecks && !isCheckExclusive && items.length"
          >
            <base-checkbox
              v-model="checkAll"
              name="all"
              class="check"
              groupLabel=""
              :label="data.label"
              @change="
                // $emit('interaction');
                checkedAll();
                $emit('interaction', checkedIds);
              "
            >
            </base-checkbox>
          </template>
          <template #empty>
            <empty-table
              :isTableInModal="isTableInModal"
              :performedSearch="performedSearch"
              :automaticPerformedSearch="automaticPerformedSearch"
              :filterCount="filterCount"
            />
          </template
          >
          <template #cell(check)="row" v-if="hasChecks">
            <span style="display: none !important" v-if="checkIsChecked">{{
              checkIsChecked(row.item)
            }}</span>
            <base-checkbox
              name="check"
              class="check"
              v-model="row.item.check"
              @change="checkedEl($event, row.index, row.item)"
              @input="
                // $emit('interaction');
                onSelectRow($event, row.index, row.item);
                $emit('interaction', checkedIds);
              "
              :hidden="
                Object.prototype.hasOwnProperty.call(
                  row.item.fattutto_transmission,
                  'transmission_status',
                ) &&
                [0, 1, 2, 5, 6].includes(
                  row.item.fattutto_transmission.transmission_status,
                )
              "
            />
          </template>
          <!-- -->
          <template #cell(actions)="row">
            <div class="action-buttons">
              <!-- <b-button
                size="sm"
                variant="lisaweb"
                class="mt-1 mr-1"
                title="Crea"
                @click="createTrasmission(row.item)"
                :disabled="
                  Object.prototype.hasOwnProperty.call(
                    row.item.fattutto_transmission,
                    'transmission_status'
                  )
                "
              >
                <b-icon icon="plus-circle"></b-icon>
              </b-button> -->
              <b-button
                size="sm"
                variant="lisaweb"
                class="mt-1 mr-1"
                title="Trasmetti"
                @click="sendOrRetryTrasmission(row.item, 'send')"
                :disabled="
                  Object.prototype.hasOwnProperty.call(
                    row.item.fattutto_transmission,
                    'transmission_status',
                  )
                "
              >
                <b-icon icon="cursor" />
              </b-button>

              <b-button
                size="sm"
                variant="lisaweb"
                class="mt-1 mr-1"
                title="Riprova trasmissione"
                @click="sendOrRetryTrasmission(row.item, 'retry')"
                :disabled="
                  !Object.prototype.hasOwnProperty.call(
                    row.item.fattutto_transmission,
                    'transmission_status',
                  ) ||
                  ![3, 4].includes(
                    row.item.fattutto_transmission.transmission_status,
                  )
                "
              >
                <base-icon name="reload" width="20" height="20" />
              </b-button>
            </div>
          </template>
          <template v-slot:[fattuttoPerc]="row">
            <template
              v-if="
                Object.prototype.hasOwnProperty.call(
                  row.item.fattutto_transmission,
                  'progress_percentage',
                ) &&
                ![0, 1, 5, 6].includes(
                  row.item.fattutto_transmission.transmission_status,
                )
              "
            >
              <div class="progress-wrapper">
                <b-progress
                  v-if="
                    (nestedValue = getNestedValue(row.item, fattutto_perc)) !=
                    null
                  "
                  :value="nestedValue"
                  :variant="getProgressBarVariant(nestedValue)"
                  class="custom-progress-bar"
                  max="100"
                ></b-progress>
                <span class="progress-value">{{
                  nestedValue != null ? `${nestedValue}%` : "-"
                }}</span>
              </div>
            </template>
            <span v-else>-</span>
          </template>
          <template v-slot:[fattuttoRecords]="row">
            <template
              v-if="
                Object.prototype.hasOwnProperty.call(
                  row.item.fattutto_transmission,
                  'record',
                ) &&
                ![0, 1, 5, 6].includes(
                  row.item.fattutto_transmission.transmission_status,
                )
              "
            >
              <span class="d-flex align-items-center" style="gap: 2px">
                <span>{{
                  getNestedValue(row.item, fattutto_records_sent)
                }}</span>
                <span class="separator">/</span>
                <span style="color: red">{{
                  getNestedValue(row.item, fattutto_records_error)
                }}</span>
                <span class="separator">/</span>
                <span>{{ getNestedValue(row.item, fattutto_records) }}</span>
                <span class="separator">/</span>
                <b-button
                  v-if="getNestedValue(row.item, fattutto_unmapped) > 0"
                  variant="link"
                  class="unmapped-link"
                  v-b-tooltip="'Mostra i movimenti non mappati'"
                  @click="
                    customOpenUnmappedModal(row.item, row.index, $event.target)
                  "
                  >{{ getNestedValue(row.item, fattutto_unmapped) }}</b-button
                >
                <span v-else style="color: blue">{{
                  getNestedValue(row.item, fattutto_unmapped) ?? "-"
                }}</span>
              </span>
            </template>
            <span v-else>-</span>
          </template>
          <template v-slot:[fattuttoErrors]="row">
            <template
              v-if="
                Object.prototype.hasOwnProperty.call(
                  row.item.fattutto_transmission,
                  'errors',
                ) &&
                ![0, 1, 5, 6].includes(
                  row.item.fattutto_transmission.transmission_status,
                )
              "
            >
              <template
                v-if="
                  (countError = getNestedValue(
                    row.item,
                    fattutto_errors,
                  ).length) != null
                "
              >
                <div
                  :class="`info-box${!countError ? ' disabled' : ''}`"
                  v-b-tooltip="{
                    title: `<ul>${renderErrors(
                      row.item.fattutto_transmission.errors,
                    )}</ul>`,
                    placement: 'left',
                    html: true,
                  }"
                  @click="
                    customOpenErrorsModal(row.item, row.index, $event.target)
                  "
                >
                  {{ countError }}
                </div>
              </template>
            </template>
            <span v-else>-</span>
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
                >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                  page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                }}</span>
              </template>
              <template v-slot:first-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                  ><base-icon
                    scale="-1"
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                  ><base-icon
                    name="chevron_right_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                  ><base-icon
                    name="chevron_right_last_rounded"
                    width="16"
                    height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
      <!-- -->
      <b-modal
        :dialog-class="customModalClass"
        :id="infomodalName"
        @show="onModalShow"
        @hidden="onModalHidden"
        :title="custoModalTitle"
        :size="custoModalSize"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  :dbRowData="dbRowData"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
      <!-- -->
    </div>
  </div>
</template>

<script>
import BaseInputPagination from "@/components/form/BaseInputPagination";
import BaseIcon from "@/components/BaseIcon";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import template from "./template";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import Errors from "@/components/fattutto/transmission/details/Errors.vue";
import Unmapped from "@/components/fattutto/transmission/details/Unmapped.vue";
import EmptyTable from "../EmptyTable.vue";

// Stati "attivi" (non terminali): la riga viene aggiornata via polling finché
// la trasmissione è in uno di questi stati. Gli stati terminali (-1 Errore,
// 3 Completato, 4 Completato con errori) fermano l'aggiornamento.
const ACTIVE_TRANSMISSION_STATUSES = [0, 1, 2, 5, 6];

export default {
  name: "FattuttoTransmissionsTableRef",
  extends: template,
  data() {
    return {
      checkedIds: [],
      fattutto_perc: "fattutto_transmission.progress_percentage",
      fattutto_records: "fattutto_transmission.record",
      fattutto_unmapped: "fattutto_transmission.unmapped",
      fattutto_records_error: "fattutto_transmission.record_error",
      fattutto_records_sent: "fattutto_transmission.record_sent",
      fattutto_errors: "fattutto_transmission.errors",
      customModalClass: "modal-fattutto-errors",
      counterSelezionate: 0,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      custoModalTitle: "Dettaglio errori",
      custoModalSize: "lg",
      modalTitleDefault: "Dettaglio errori",
      modalTitleGroup: "Dettaglio errori",
      modalSizeGroup: "lg",
      modalSizeDefault: "lg",
      tabs: [
        { name: "Errors", text: "Errori" },
        { name: "Unmapped", text: "Non mappati" },
      ],
      selected: "Errors", // dynamically load selected component in tabs
      modalResourceId: null, // prop for the dynamic components
      tabIndex: 0, // remember last visited tab: set active tab when modal gets opened
      dbRowData: null, // used to pass the actual record to tabs
      pollingTimer: null, // setInterval per l'aggiornamento dinamico delle righe in lavorazione
      pollingIntervalMs: 5000,
      isPollingInProgress: false, // evita tick di polling sovrapposti
    };
  },
  props: {
    hasChecksPaginated: {
      type: Boolean,
      default: false,
    },
    automaticPerformedSearch: {
      type: Boolean,
      default: false
    },
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EmptyTable,
    BaseIcon,
    BaseCheckbox,
    BaseInputPagination,
    Errors,
    Unmapped,
  },
  methods: {
    onModalShow() {
      if (this.tabIndex < this.tabs.length)
        this.setTab(this.tabs[this.tabIndex], this.tabIndex);
    },
    onModalHidden() {
      this.setTab({ name: "Errors", text: "Errori" }, 0);
      this.customModalClass = "modal-fattutto-errors";
      this.custoModalTitle = this.modalTitleDefault;
      this.custoModalSize = this.modalSizeDefault;
    },
    customOpenErrorsModal(item, index, target) {
      this.tabIndex = 0; // TabIndex ID delle Note
      this.openModal(item, index, target);
    },
    customOpenUnmappedModal(item, index, target) {
      this.tabIndex = 1; // tab Non mappati
      this.openModal(item, index, target);
    },
    onSendOrRetry() {
      this.selectedRows = [];
      this.checkedIds = [];
      this.checkAll = false;
      this.$emit("onSendOrRetry");
      /* emit these
       * this.hasUserInteraction = false;
       * this.$refs[this.tableRef].fetch(this.current_config);
       */
    },
    changeCheckAll(condition, event) {
      console.log("event", event);
      this.checkAll = condition;
    },
    checkIsChecked(item) {
      // const evl = this.checkedIds.indexOf(item.consolidated_at) >= 0;
      const evl = this.checkedIds.some(
        (el) => el.consolidated_at === item.consolidated_at,
      );
      item.check = evl;
      return evl;
    },
    checkedEl(event, index, item) {
      console.log("clicked :", index);
      if (!this.hasChecksPaginated) return;
      // if (event && this.checkedIds.indexOf(item.consolidated_at) === -1) {
      const i = this.checkedIds.findIndex(
        (el) => el.consolidated_at === item.consolidated_at,
      );
      if (event && i === -1) {
        // this.checkedIds.push(item.consolidated_at);
        this.checkedIds.push(item);
      } else {
        // const i = this.checkedIds.indexOf(item.consolidated_at);
        // const i = this.checkedIds.findIndex(
        //   (el) => el.consolidated_at === item.consolidated_at
        // );
        if (i > -1) {
          this.checkedIds.splice(i, 1);
        }
      }
      this.$emit("singleCheck", this.checkedIds);
    },
    checkedAll() {
      this.items.forEach((item) => {
        this.checkedEl(true, null, item);
      });
    },
    renderErrors(errors) {
      return errors.map((el) => `<li>${el}</li>`).join("");
    },
    sendOrRetryTrasmission(item, action) {
      const payload = {
        date: item.consolidated_at,
      };
      this.isLoading = true;
      const Repo = RepositoryFactory.get("fattutto");
      (action === "send"
        ? Repo.send_transmission(payload)
        : Repo.retry_transmission(item.fattutto_transmission.id)
      )
        .then(() => {
          this.$emit("transmissionActionsEnd");
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: ${
              action === "send"
                ? "Trasmissione Inviata"
                : "Nuovo tentativo di trasmissione inviato"
            }`,
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
      // .finally(() => {
      //   this.isLoading = false;
      // });
    },
    // createTrasmission(item) {
    //   this.isLoading = true;
    //   const Repo = RepositoryFactory.get("fattutto");
    //   const payload = {
    //     date: item.consolidated_at,
    //   };
    //   Repo.create_transmission(payload)
    //     .then(() => {
    //       this.$emit("transmissionActionsEnd");
    //       this.$showSnackbar({
    //         preset: "success",
    //         text: `Azione Completata: Trasmissione Creata`,
    //       });
    //     })
    //     .catch((error) => {
    //       let errMsg = this.$getErrorMessage(error);
    //       this.$showSnackbar({
    //         preset: "error",
    //         text: `${errMsg}`,
    //       });
    //     });
    //   // .finally(() => {
    //   //   this.isLoading = false;
    //   // });
    // },
    getNestedValue(obj, path) {
      return path
        .split(".")
        .reduce((acc, key) => (acc ? acc[key] : undefined), obj);
    },
    getProgressBarVariant(value) {
      let ret = "";
      switch (true) {
        case value < 25:
          ret = "danger";
          break;
        case value >= 25 && value < 100:
          ret = "warning";
          break;
        case value == 100:
          ret = "success";
          break;
        default:
          ret = "info";
          break;
      }
      return ret;
    },
    /* Aggiornamento dinamico (polling) delle righe in lavorazione */
    getActiveTransmissionDates() {
      return this.items
        .filter(
          (item) =>
            item.fattutto_transmission &&
            ACTIVE_TRANSMISSION_STATUSES.includes(
              item.fattutto_transmission.transmission_status,
            ),
        )
        .map((item) => item.consolidated_at);
    },
    refreshTransmissionRow(date) {
      const Repo = RepositoryFactory.get("fattutto");
      return Repo.index_transmission(`date_from=${date}&date_to=${date}`)
        .then((response) => {
          const rows = response?.data?.data ?? [];
          const fresh = rows.find((row) => row.consolidated_at === date);
          if (!fresh) return;
          // re-find l'indice al momento del merge: la tabella potrebbe essere
          // stata ricaricata da un fetch concorrente nel frattempo
          const index = this.items.findIndex(
            (item) => item.consolidated_at === date,
          );
          if (index === -1) return;
          this.$set(this.items, index, {
            ...this.items[index],
            ...fresh,
            check: this.items[index].check,
          });
        })
        .catch(() => {
          // refresh di background: resta silenzioso, niente snackbar
        });
    },
    pollActiveTransmissions() {
      // non sovrapporsi a un fetch completo né a un tick precedente
      if (this.isLoading || this.isPollingInProgress) return;
      const dates = this.getActiveTransmissionDates();
      if (!dates.length) {
        this.stopPolling();
        return;
      }
      this.isPollingInProgress = true;
      Promise.all(dates.map((date) => this.refreshTransmissionRow(date))).finally(
        () => {
          this.isPollingInProgress = false;
        },
      );
    },
    startPolling() {
      this.stopPolling();
      this.pollingTimer = setInterval(
        this.pollActiveTransmissions,
        this.pollingIntervalMs,
      );
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    syncPolling() {
      // avvia il polling se ci sono righe attive e non è già in corso;
      // lo stop è gestito dal tick stesso quando non restano righe attive
      if (this.getActiveTransmissionDates().length && !this.pollingTimer) {
        this.startPolling();
      }
    },
  },
  watch: {
    items() {
      this.syncPolling();
    },
  },
  beforeDestroy() {
    this.stopPolling();
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    fattuttoPerc() {
      return `cell(${this.fattutto_perc})`;
    },
    fattuttoRecords() {
      return `cell(${this.fattutto_records})`;
    },
    fattuttoErrors() {
      return `cell(${this.fattutto_errors})`;
    },
  },
  // beforeMount() {
  //   this.actions.push("infomodal");
  // },
};
</script>

<style lang="css" scoped>
.unmapped-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5em;
  height: 1.5em;
  padding: 0 0.4em;
  border: 0;
  border-radius: var(--radius-pill);
  font-size: inherit;
  line-height: 1;
  background-color: blue;
  color: #fff;
  text-decoration: none;
}

.unmapped-link:hover,
.unmapped-link:focus {
  color: #fff;
  text-decoration: none;
}

:deep(.progress-wrapper) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 90px;
}

:deep(.progress) {
  width: 50px;
  height: 5px;
  border: 0;
  border-radius: var(--radius-pill);
}

:deep(td.check) {
  padding: 0;
}

:deep(td.check span.check) {
  display: flex;
  justify-content: center;
  translate: 0 2px;
}

:deep(th.check .form-group) {
  margin: 0;
}

:deep(td.check .form-group) {
  margin: 0;
}

:deep(td.check .custom-checkbox + .invalid-feedback) {
  margin: 0;
}
</style>
